import './../main.js'
import { createApp } from 'vue'

// import Trenders from './apps/Trenders.vue'
// import News from './apps/News.vue'
import ContactForm from './apps/ContactForm.vue'
import NewsletterForm from './apps/NewsletterForm.vue'
import Articles from './apps/Articles.vue'
import ArticlesOverview from './apps/ArticlesOverview.vue'
import BreadcrumbApp from './apps/BreadcrumbApp.vue'
import Reasons from './apps/Reasons.vue'
import Products from './apps/ProductsApp.vue'
import ToggleMenuData from './apps/ToggleMenuData.vue'
import Wizard from './apps/WizardApp.vue'
import Chartjs from './apps/ChartjsApp.vue'
import PriceSheetApp from './apps/PriceSheetApp.vue'
import AmoivaiaCalculatorPast from './apps/AmoivaiaCalculatorPast.vue'
import AmoivaiaCalculator from './apps/AmoivaiaCalculator.vue'
import Video from './apps/Video.vue'
import Contact from './apps/Contact.vue'
import InfoTabsApp from './apps/InfoTabsApp.vue'
import SearchResultsApp from './apps/SearchResultsApp.vue'
import ResultsTableApp from './apps/ResultsTableApp.vue'
import History from './apps/History.vue'

import { autoAnimatePlugin } from '@formkit/auto-animate/vue'

if (document.getElementById('app-contact-form')) {
  const { dictionary, configuration } = window['contactFormData']
  const app = createApp(ContactForm)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-contact-form')
}

if (document.getElementById('app-newsletter-form')) {
  const { dictionary, configuration } = window['newsletterFormData']
  const app = createApp(NewsletterForm)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-newsletter-form')
}

if (document.getElementById('app-articles')) {
  const { dictionary, configuration } = window['articlesData']
  const app = createApp(Articles)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-articles')
}

if (document.getElementById('app-articles-overview')) {
  const { dictionary, configuration } = window['articlesOverviewData']
  const app = createApp(ArticlesOverview)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-articles-overview')
}

if (document.getElementById('price-sheet-app')) {
  const { dictionary, configuration } = window['priceSheetData']
  const app = createApp(PriceSheetApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#price-sheet-app')
}

// breadcrumb app
const breadcrumbAppId = 'breadcrumb-app'
if (document.getElementById(breadcrumbAppId)) {
  const { dictionary, configuration } = window['breadcrumbData']
  const app = createApp(BreadcrumbApp)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )
  app.mount(`#${breadcrumbAppId}`)
}

if (document.getElementById('app-reasons')) {
  const { dictionary, configuration } = window['reasonsData']
  const app = createApp(Reasons)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-reasons')
}

if (document.getElementById('app-products')) {
  const { dictionary, configuration } = window['productsData']
  const app = createApp(Products)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-products')
}

if (document.getElementById('app-wizard-new')) {
  const { dictionary, configuration } = window['wizardDataNew']
  const app = createApp(Wizard)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-wizard-new')
}

let toggleApp = []
const toggleDiv = document.querySelectorAll('.app-toggle')
if (toggleDiv.length) {
  for (let i = 0; i < toggleDiv.length; ++i) {
    if (toggleDiv[i].id && toggleDiv[i].id !== '') {
      toggleApp.push(createApp({ ...ToggleMenuData }))
      toggleApp[i].mount(`#${toggleDiv[i].id}`)
    }
  }
}

let chartjsApps = []
const emptyAppDivs = document.querySelectorAll('.chartjs-apps')
if (emptyAppDivs.length) {
  for (let i = 0; i < emptyAppDivs.length; ++i) {
    const app = emptyAppDivs[i].querySelector('.chartjs-apps__app')

    if (app && app.id) {
      chartjsApps.push(createApp({ ...Chartjs }))

      console.log(emptyAppDivs[i].dataset.filters)

      if (emptyAppDivs[i].dataset && emptyAppDivs[i].dataset.handler) {
        Object.assign(chartjsApps[i].config.globalProperties, {
          handler: emptyAppDivs[i].dataset.handler,
          filterHandler: emptyAppDivs[i].dataset.filters,
          shareClassCode: emptyAppDivs[i].dataset.shareclasscode,
          mutualFundCode: emptyAppDivs[i].dataset.mutualfundcode,
          fromLabel: emptyAppDivs[i].dataset.from,
          toLabel: emptyAppDivs[i].dataset.to,
          dateFrom: emptyAppDivs[i].dataset.datefrom,
          dateTo: emptyAppDivs[i].dataset.dateto,
        })

        chartjsApps[i].mount(`#${app.id}`)
      }
    }
  }
}

if (document.getElementById('amoivaia-calculator-app')) {
  const { dictionary, configuration } = window['amoivaiaCalculatorData']
  const app = createApp(AmoivaiaCalculator)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#amoivaia-calculator-app')
}

if (document.getElementById('amoivaia-calculator-past-app')) {
  const { dictionary, configuration } = window['amoivaiaCalculatorPastData']
  const app = createApp(AmoivaiaCalculatorPast)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#amoivaia-calculator-past-app')
}

if (document.getElementById('app-video')) {
  const { dictionary } = window['videosData']
  const app = createApp(Video)

  Object.assign(app.config.globalProperties, { dictionary: dictionary })

  app.mount('#app-video')
}

if (document.getElementById('contact')) {
  const { dictionary, configuration } = window['contactData']
  const app = createApp(Contact)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#contact')
}

// let netPriceApp = []
// const netPriceDiv = document.querySelectorAll('.net-price-app')
// if (netPriceDiv.length) {
//   for (let i = 0; i < netPriceDiv.length; ++i) {
//     if (netPriceDiv[i].id && netPriceDiv[i].id !== '') {
//       netPriceApp.push(createApp({ ...NetPriceApp }))
//       netPriceApp[i].mount(`#${netPriceDiv[i].id}`)
//     }
//   }
// }



if (document.getElementById('info-tab-app')) {
  const { dictionary, configuration } = window['infoTabsDataApp']
  const app = createApp(InfoTabsApp).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },   
  )

  app.mount('#info-tab-app')
}

if (document.getElementById('search-results-app')) {
  const { dictionary, configuration } = window['searchResultsData']
  const app = createApp(SearchResultsApp )

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#search-results-app')
}

if (document.getElementById('results-table-app')) {
  const { dictionary, configuration } = window['resultsTableData']
  const app = createApp(ResultsTableApp )

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#results-table-app')
}

if (document.getElementById('history-app')) {
  const { dictionary, configuration } = window['historyData']
  const app = createApp(History)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#history-app')
}
